export const iconFontAwesomeMathematicsCalculator = (
	<i className="fa-solid fa-calculator"></i>
);
